// Panel del modulo (D26): la columna junto al riel con las secciones del modulo abierto y su accion principal
// (p. ej. "Nuevo contacto" en Clientes). Un modulo de una sola seccion no lo necesita y no se muestra.
// En el celular, las mismas secciones van como pestanas bajo la barra superior (SeccionesMovil).
import { Link } from 'react-router-dom';

import { Icon, type IconName } from '../lib/icons';
import type { Modulo, ModuloId } from './menu';
import { useContadores, useNavegacion } from './navegacion';
import { AbiertosAhora, VistasNav } from '../screens/bandeja/useVistas';

type Accion = { texto: string; icono: IconName; hacer: () => void };

// La accion principal del modulo va arriba del panel. Por ahora cada pantalla ya trae su boton "Nuevo…"; aqui
// entran las que no tienen pantalla propia (p. ej. "Redactar" en la Bandeja cuando llegue el correo).
function accionDe(id: ModuloId): Accion | null {
  void id;
  return null;
}

export const usaPanel = (m: Modulo | undefined) => !!m && m.secciones.length > 1;

export function PanelModulo() {
  const { actual } = useNavegacion();
  const contadores = useContadores();
  const m = actual?.modulo;
  if (!m || !usaPanel(m)) return null;
  const accion = accionDe(m.id);
  return (
    <aside className="panel-mod" aria-label={m.nombre}>
      <div className="pm-h">
        <h2>{m.nombre}</h2>
        {accion ? (
          <button className="btn sm primary" onClick={accion.hacer}>
            <Icon name={accion.icono} /> {accion.texto}
          </button>
        ) : null}
      </div>
      <nav className="pm-nav" aria-label={`Secciones de ${m.nombre}`}>
        {m.secciones.map((s, i) => {
          const c = s.contador ? contadores[s.contador] : null;
          // Titulo del grupo cuando cambia (D96: Ventas en Comercial, Proyectos, Soporte y Licencias 3CX).
          const grupo = s.grupo && s.grupo !== m.secciones[i - 1]?.grupo ? s.grupo : null;
          return (
            <div key={s.ruta} className="pm-item">
              {grupo ? <div className="pm-grupo">{grupo}</div> : null}
              <Link to={s.ruta} aria-current={actual?.seccion.ruta === s.ruta ? 'page' : undefined} data-baliza={s.ruta === '/reportes/3cx' ? 'reportes-3cx' : undefined}>
                <Icon name={s.icono} />
                <span className="t">{s.nombre}</span>
                {c?.n ? <span className={`cnt ${c.tono ?? ''}`}>{c.n}</span> : null}
              </Link>
              {s.ruta === '/bandeja/casos' ? <VistasNav /> : null}
            </div>
          );
        })}
      </nav>
      {m.id === 'bandeja' ? <AbiertosAhora /> : null}
    </aside>
  );
}

export function SeccionesMovil() {
  const { actual } = useNavegacion();
  const contadores = useContadores();
  const m = actual?.modulo;
  if (!m || !usaPanel(m)) return null;
  return (
    <nav className="subnav secciones-movil" aria-label={`Secciones de ${m.nombre}`}>
      {m.secciones.map((s) => {
        const c = s.contador ? contadores[s.contador] : null;
        return (
          <Link key={s.ruta} to={s.ruta} aria-current={actual?.seccion.ruta === s.ruta ? 'page' : undefined} data-baliza={s.ruta === '/reportes/3cx' ? 'reportes-3cx' : undefined}>
            {s.nombre}
            {c?.n ? <span className={`cnt ${c.tono ?? ''}`}>{c.n}</span> : null}
          </Link>
        );
      })}
    </nav>
  );
}
